import App from './App'
import router from './router'
import store from './store/index'
// import ElementUI from 'element-ui'
import '@/permission'
import '@/icons'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import lang from '@/language/index' //中英文翻译
import filters from './filter/index.js'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/style.css'
import Version from './const/Version.vue'
import Global from './const/Global.vue'
import PROVINCE from './const/PROVINCE.vue'
import tool from "./utils/tool";
import footer from '@/components/nav/footer.vue'
import logRegFooter from '@/components/nav/log_reg_footer.vue'
const Vue = require('vue')
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
Vue.use(tool)
Vue.component('Footer', footer)
Vue.component('LogRegFooter', logRegFooter)
const ElementUI = require('element-ui')
const i18n=new VueI18n({
  locale:localStorage.getItem('languageSet')||'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
  messages:{
    'zh':{
      ...lang.zh,
      // ...zhLocale
    },
    'en':{
      ...lang.en,
      // ...enLocale
    }
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.Version = Version;
Vue.prototype.Global = Global;


Vue.filter('formatDateTime', function (value) {
  if (!value) return ''
  let date = new Date(value);
  let y = date.getFullYear() + '/';
  let mon = (date.getMonth() + 1) + '/';
  let d = date.getDate();
  return y + mon + d;
});
for (let filter in filters) {
  Vue.filter(filter, filters[filter]);
}
new Vue({
  router,
  store,
  i18n,   //把 i18n 挂载到 vue 根实例上
  el: '#app',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js